import { ApiConfig } from "common/models";
import { CONTROLLER } from "common/config/endpoint.config";
import { buildGdxApiUrl } from "common/utils/api.util";

export const configConfig = {
  getAllConfigurations: (): ApiConfig => {
    return new ApiConfig(
      buildGdxApiUrl(`${CONTROLLER.GDX_DATABASE}/config/get-all`),
      "GET",
      "",
      undefined
    );
  },

  createConfiguration: (configData: any): ApiConfig => {
    return new ApiConfig(
      buildGdxApiUrl(`${CONTROLLER.GDX_DATABASE}/config/create-with-fields`),
      "POST",
      undefined,
      configData
    );
  },

  updateConfiguration: (configData: any): ApiConfig => {
    return new ApiConfig(
      buildGdxApiUrl(`${CONTROLLER.GDX_DATABASE}/config/upsert`),
      "POST",
      undefined,
      configData
    );
  },

  deleteConfiguration: (configId: number): ApiConfig => {
    return new ApiConfig(
      buildGdxApiUrl(`${CONTROLLER.GDX_DATABASE}/config/delete/${configId}`),
      "DELETE",
      configId.toString(),
      undefined
    );
  }
};
